// src/features/taxContext/TaxYearSelector.js
import React from 'react'

const TaxYearSelector = ({
  value,
  onChange,
  label = 'Tax Year',
}) => {
  const currentYear = new Date().getFullYear()

  const years = []
  for (let i = currentYear; i >= currentYear - 5; i--) {
    years.push(i)
  }

  return (
    <div>
      <label className="mb-1 block text-sm font-medium text-slate-700">
        {label}
      </label>

      <select
        value={value || ''}
        onChange={(e) => onChange(Number(e.target.value))}
        className="w-full rounded-xl border border-slate-300 px-3 py-2 text-sm outline-none focus:border-slate-400"
      >
        <option value="">Select year</option>

        {years.map((year) => (
          <option key={year} value={year}>
            {year}
          </option>
        ))}
      </select>
    </div>
  )
}

export default TaxYearSelector